import React from 'react'

import { Button, Dialog, DialogBody, DialogFooter, DialogHeader, Paragraph } from '../../components'

export enum IdeaDrawingsConfirmationOptions {
  Merge,
  Override,
  Nothing,
  Cancel,
}

interface IIdeaLeaveDialog {
  state: any
  actionCallback: (action: IdeaDrawingsConfirmationOptions) => void
}

export function IdeaLeaveDialog({ actionCallback, state }: IIdeaLeaveDialog) {
  return (
    <Dialog
      state={state}
      aria-label="You are leaving your idea, what would you like to do with the drawings from your currently open idea?"
      className="w-96"
      onOverlayClick={() => actionCallback(IdeaDrawingsConfirmationOptions.Cancel)}
    >
      <DialogHeader onCloseClick={() => actionCallback(IdeaDrawingsConfirmationOptions.Cancel)}>
        You are leaving your idea
      </DialogHeader>
      <DialogBody>
        <div className="space-y-4">
          <Paragraph>What would you like to do with the drawings from your currently open idea?</Paragraph>
          <Paragraph>
            <strong>Override drawings:</strong>
            <br />
            Your autosaved drawings for the current ticker will be removed and drawings from the idea will be copied to
            a live chart.
          </Paragraph>
          <Paragraph>
            <strong>Merge drawings:</strong>
            <br />
            Drawings from the idea will be copied to a live chart without affecting the positions or settings of any
            autosaved drawings. This may result in duplicated drawings if some of them were also saved in the idea.
          </Paragraph>
          <Paragraph>
            <strong>Nothing:</strong>
            <br />
            The idea will close without affecting any autosaved drawings.
          </Paragraph>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button
          data-testid="confirmation-dialog-override"
          onClick={() => actionCallback(IdeaDrawingsConfirmationOptions.Override)}
        >
          Override
        </Button>
        <Button
          data-testid="confirmation-dialog-merge"
          onClick={() => actionCallback(IdeaDrawingsConfirmationOptions.Merge)}
        >
          Merge
        </Button>
        <Button
          data-testid="confirmation-dialog-nothing"
          onClick={() => actionCallback(IdeaDrawingsConfirmationOptions.Nothing)}
        >
          Nothing
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
